module.exports = __webpack_public_path__ + "img/3.8d29e3ce.png";